<template>
  <div class="index-works">
    <div class="works-title">
      <h2>
        {{ $t('works.title') }}
        <br />
        <sub>{{ $t('works.sub-title') }}</sub>
      </h2>
    </div>
    <div class="works-content">
      <el-carousel :interval="4000" type="card" v-if="list.length">
        <el-carousel-item v-for="item in list" :key="item.id">
          <div class="works-img" @click="toNews(item)">
            <img :src="item.showImg" :alt="item.showImg" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { newWindowOpen } from '@/utils/tools'
import * as ConstantRouter from '@/constant/router'

export default {
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      const [err, res] = await this.$serve.jsArticle.getPageList({
        data: {
          pageIndex: 1,
          pageSize: 6,
          jsId: this.jsId,
          articleType: 5
        }
      })
      if (err) return
      this.list = res.records
    },
    toNews(item) {
      newWindowOpen({
        name: ConstantRouter.NEWS,
        params: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.index-works {
  width: 1320px;
  margin: 80px auto 0;
}
.works-title {
  text-align: center;
  margin-bottom: 40px;
}
.works-img {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  cursor: pointer;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

@media (max-width: 1199px) {
  .index-works {
    width: 100%;
    padding: 0 20px;
  }
}

@media (max-width: 414px) {
  ::v-deep {
    .el-carousel__container {
      height: 150px;
    }
  }
}
</style>
